<template>
  <div class="container">
    <el-button class="publicBtn returnList"
               @click="returnList">返回</el-button>
    <p class="title">{{noticeData.title}}</p>
    <p class="noticeUser">管理员通知</p>
    <div class="line"></div>
    <div class="content">{{noticeData.content}}</div>
  </div>
</template>

<script>
import { getNoticeInfo } from "common/js/api";

export default {
  data () {
    return {
      currentPage: this.$route.query.currentPage,
      pageSize: this.$route.query.pageSize,
      userCode: this.$route.query.userCode,
      id: this.$route.query.id,
      noticeData: {}
    };
  },

  created () {
    this.getList();
  },

  methods: {
    async getList () {
      const data = {
        page: this.currentPage,
        size: this.pageSize,
        userInstitutionCode: this.userCode
      };

      const { result } = await getNoticeInfo(data);
      this.noticeData = result.list.filter(item => item.id == this.id)[0];

    },

    returnList () {
      this.$router.push("/UC/InfoCenter");
    }
  }
};
</script>

<style scoped>
.container {
  height: 100%;
  position: relative;
  background-color: white;
  border-radius: 4px;
  padding: 30px 20px;
}

.returnList {
  position: absolute;
  right: 20px;
  top: 30px;
}

.title {
  font-size: 27px;
  font-weight: 600;
}

.noticeUser {
  color: #949393;
  margin: 15px 0px;
}

.line {
  border: 1px dashed #949393;
  margin-bottom: 10px;
}

.content {
  color: #949393;
  font-size: 17px;
}
</style>